import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const REDIRECT_KEY = 'redirect_after_auth';

/**
 * When the user becomes authenticated, consume any URL stashed under
 * `redirect_after_auth` in sessionStorage and navigate there. Used to
 * return the user to a protected page (e.g. `/auth/device?user_code=...`)
 * after login/signup.
 */
export function usePostAuthRedirect(isAuthenticated: boolean): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return;
    const redirectPath = sessionStorage.getItem(REDIRECT_KEY);
    if (redirectPath) {
      sessionStorage.removeItem(REDIRECT_KEY);
      navigate(redirectPath, { replace: true });
    }
  }, [isAuthenticated, navigate]);
}
